import { SurveyQuestion } from '@/types/Psychosocial';

export type SaveAnswerFn = (questionId: string, value: string) => Promise<void>;

export interface Option {
	id: string;
	name: string;
	value: string;
}

export interface PairComparison {
	questionId: string;
	option1: Option;
	option2: Option;
}

export interface WorkloadSectionProps {
	workloadQuestions: SurveyQuestion[];
	saveAnswer?: SaveAnswerFn;
}

export interface DefaultQuestionProps {
	question: SurveyQuestion;
	isMobile: boolean;
	index?: number;
	saveAnswer?: SaveAnswerFn;
}

export interface QuestionHeaderProps {
	title: string;
	description: string;
	index?: number;
}

export interface RadioQuestionProps {
	options: Option[];
}

export interface SliderMarks {
	[key: number]: string;
}

export interface WorkloadComparisonProps {
	comparison: PairComparison;
	saveAnswer?: SaveAnswerFn;
}

export enum SurveySection {
	RADIO = 'radio',
	SLIDER = 'slider',
	WORKLOAD = 'workload'
}

export interface PaginationConfig {
	currentSection: SurveySection;
	currentPage: number;
	handleNext: () => void;
	handleBack: () => void;
	goToPage: (page: number, sectionIndex?: number) => void;
	hasNext: () => boolean;
	hasBack: () => boolean;
	getTotalPages: () => number;
	getCurrentQuestions: () => SurveyQuestion[];
	isLastSection: boolean;
}

export interface PaginationControlsProps {
	isMobile: boolean;
	currentPage: number;
	totalPages: number;
	hasNext: () => boolean;
	hasBack: () => boolean;
	handleNext: () => void;
	handleBack: () => void;
	goToPage: (page: number, sectionIndex?: number) => void;
	handleSaveResponses: () => void;
}

export interface SurveyContentProps {
	currentSection: SurveySection;
	currentQuestions: SurveyQuestion[];
	isMobile: boolean;
	workloadQuestions: SurveyQuestion[];
	saveAnswer?: SaveAnswerFn;
}

export interface Question {
	id: string;
	title: string;
	description?: string;
	category?: string;
	options?: Array<{
		id: string;
		name: string;
		value: string;
	}>;
}

export interface Answer {
	question_id: string;
	option_id?: string;
	response?: string;
}

export interface SurveyPaginationProps {
	workloadQuestions: SurveyQuestion[];
	sliderQuestions: SurveyQuestion[];
	radioQuestions: SurveyQuestion[];
	questionsPerPage: number;
	isMobile: boolean;
}

export interface SectionData {
	questions: SurveyQuestion[];
	type: SurveySection;
}

export interface PaginationState {
	currentQuestions: SurveyQuestion[];
	currentSection: SectionData | null;
	currentPageInSection: number;
	currentSectionIndex: number;
	isLastPage: boolean;
	totalPages: number;
}
